/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-14 10:41:30
 */
export const MEUNS_LIST = 'MEUNS_LIST';

export const SUB_MEUNS_LIST = 'SUB_MEUNS_LIST';

export const LOGIN_STATUS = 'LOGIN_STATUS';

export const PAGE_LOADING = 'PAGE_LOADING';

export const USER_INFO = 'USER_INFO';

export const SHARE_ID = 'SHARE_ID';

export const SHOP_ID = 'SHOP_ID';

export const BASE_INFO = 'BASE_INFO';

export const INVITE_DATA = 'INVITE_DATA';

export const DY_CATEGORY = 'DY_CATEGORY';

export const KS_CATEGORY = 'KS_CATEGORY';

export const SP_CATEGORY = 'SP_CATEGORY';

export const TEAM_CONFIG = 'TEAM_CONFIG';

export const ALERT_MSG = 'ALERT_MSG';

export const HOST_APP_KEY = 'HOST_APP_KEY';

export const CHANGE_READY = 'CHANGE_READY';

export const SET_SYSTEM_CONF = 'SET_SYSTEM_CONF';

export const BIND_ROLES = 'BIND_ROLES';

export const PERMISSION_INFO = 'PERMISSION_INFO';

export const USER_TYPE_LIST = 'USER_TYPE_LIST';

export const DATA_VIEW_LIST = 'DATA_VIEW_LIST';

export const DATA_VIEW_ID = 'DATA_VIEW_ID';

export const COMMISSION_RULES = 'COMMISSION_RULES';

export const USER_ID = 'USER_ID';

export const TENANT_ID = 'TENANT_ID';

export const ROLE_ID = 'ROLE_ID';

export const SPH_EXPO_NAME = 'SPH_EXPO_NAME';

export const NEW_FUNCS_VIEWED = 'NEW_FUNCS_VIEWED';

export const CONTENT_LOAD = 'CONTENT_LOAD';

export const SET_DICT_DATAS = 'SET_DICT_DATAS';

export const SET_PLATFORM = 'SET_PLATFORM';

export const UPDATE_INFO = 'UPDATE_INFO';
